export const bestBSchoolsStaticData = (activeYear) => [
  {
    name: "Overall",
    key: "overall",
  },
  {
    name: "Zone",
    key: "zone",
    urls: [
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-east.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-west.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-north.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-south.json`,
    ],
  },
  {
    name: "City",
    key: "city",
    urls: [
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-bengaluru.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-delhi.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-mumbai.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-coimbatore.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-hyderabad.json`,
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-kolkata.json`,
    ],
  },
  {
    name: "Private",
    key: "private",
    urls: [`https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-pvt.json`],
    title: "Private Rank",
  },
  {
    name: "University",
    key: "university",
    urls: [
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-university.json`,
    ],
    title: "University Rank",
  },
  {
    name: "Non University",
    key: "non-university",
    urls: [
      `https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-non-university.json`,
    ],
    title: "Non University Rank",
  },
  {
    name: "Government",
    key: "government",
    urls: [`https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com/bschool-data/${activeYear}-bschool-gov.json`],
    title: "Government Rank",
  },
];
